import React from 'react';
import { PropTypes, describe } from 'react-desc';
import FilterBarImpl from './FilterBarImpl.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-basic/Button';
import './FilterLabeledPills.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-basic/Pills';
import './FilterDropdownPill.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import './transformFilters.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'memoize-one';

var DSFilterBar = function DSFilterBar(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      innerRef = _ref.innerRef,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      _ref$fixedFilters = _ref.fixedFilters,
      fixedFilters = _ref$fixedFilters === void 0 ? [] : _ref$fixedFilters,
      _ref$onRemoveFilter = _ref.onRemoveFilter,
      onRemoveFilter = _ref$onRemoveFilter === void 0 ? function () {
    return null;
  } : _ref$onRemoveFilter,
      _ref$onRemoveAllFilte = _ref.onRemoveAllFilters,
      onRemoveAllFilters = _ref$onRemoveAllFilte === void 0 ? function () {
    return null;
  } : _ref$onRemoveAllFilte,
      _ref$onChangeDropdown = _ref.onChangeDropdownPill,
      onChangeDropdownPill = _ref$onChangeDropdown === void 0 ? function () {
    return null;
  } : _ref$onChangeDropdown,
      _ref$renderToolbar = _ref.renderToolbar,
      renderToolbar = _ref$renderToolbar === void 0 ? undefined : _ref$renderToolbar,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React.createElement(FilterBarImpl, {
    ref: innerRef,
    className: className,
    containerProps: containerProps,
    filters: filters,
    fixedFilters: fixedFilters,
    maxWidth: maxWidth,
    minWidth: minWidth,
    onChangeDropdownPill: onChangeDropdownPill,
    onRemoveAllFilters: onRemoveAllFilters,
    onRemoveFilter: onRemoveFilter,
    renderToolbar: renderToolbar,
    style: style
  });
};

var props = {
  /** props to inject to filter bar wrapper */
  containerProps: PropTypes.object.description('props to inject to filter bar wrapper'),

  /**
   * Refence to the component
   */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]).description('reference to the component'),

  /** class for filter bar wrapper */
  className: PropTypes.string.description(' class for filter bar wrapper'),

  /**
   * Customized filters to add to the filter bar
   */
  filters: PropTypes.arrayOf(PropTypes.object).description('Customized filters to add to the filter bar'),

  /**
   * Customized filters that cannot be deleted from the filter bar
   */
  fixedFilters: PropTypes.arrayOf(PropTypes.object).description('Customized filters that cannot be deleted from the filter bar'),

  /**
   * Allows a function to be triggered once a filter is removed
   */
  onRemoveFilter: PropTypes.func.description('Allows a function to be triggered once a filter is removed'),

  /**
   * Allows a function to be triggered once all filters are removed
   */
  onRemoveAllFilters: PropTypes.func.description('Allows a function to be triggered once all filters are removed'),

  /**
   * Allows a function to be triggered once a dropdown pill changes
   */
  onChangeDropdownPill: PropTypes.func.description('Allows a function to be triggered once a dropdown pill changes'),

  /**
   * Allows a function to render a toolbar
   */
  renderToolbar: PropTypes.func.description('Allows a function to render a toolbar'),

  /**
   * Set style for the filter bar
   */
  style: PropTypes.object.description('Set style for the filter bar'),

  /** max width for filterbar */
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('max width for filterbar'),

  /** min width for filterbar */
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('min width for filterbar')
};
DSFilterBar.propTypes = props;
var DSFilterBarWithSchema = describe(DSFilterBar);
DSFilterBarWithSchema.propTypes = props;

export default DSFilterBar;
export { DSFilterBarWithSchema };
//# sourceMappingURL=DSFilterBar.js.map
